import React, { useCallback, useMemo } from "react";
import SelectGroup from "../../witadmin/CRUD/Common/SelectGroup";
import styled from "styled-components";
import { AllowedLocales, getTranslatedCountryList } from "../../../lib/intlUtils";
import { useLocaleProvider } from "../../../components/locale-provider";
import { InputWidgetProps } from ".";

const SelectGroupWrapper = styled.div`
  display: flex;
  max-width: 200px;
  margin-bottom: -20px;
`;

export function CountrySelector({ value, onChange, schema }: InputWidgetProps) {
  const locale = useLocaleProvider();
  const countryList = useMemo(() => {
    if (locale?.currentLocale?.substring(0, 2)) {
      return getTranslatedCountryList(locale?.currentLocale?.substring(0, 2) as AllowedLocales)
        .reverse()
        .reduce((accum, curr) => {
          return {
            [curr.value]: { label: curr.label },
            ...accum,
          };
        }, {});
    }
  }, [locale]);
  
  const handleChange = useCallback(
    event => {
      onChange(event.target.value);
    },
    [onChange]
  );

  return (
    <SelectGroupWrapper>
      <SelectGroup
        value={value}
        field={{
          fieldName: "type",
          widget: "selector",
          optionDisplay: countryList,
        }}
        onChange={({ event, field }) => {
          handleChange(event);
        }}
        errors={undefined}
        additionalFields={undefined}
        className={undefined}
      />
    </SelectGroupWrapper>
  );
}